module.exports = __webpack_public_path__ + "img/day1-selected.58168143.svg";